import { IDeleteDiarioObraImagensUseCase } from "../../../presentation/useCases/delete/delete_diario_obras_imagens_use_case";
import { IDiarioObraRepository } from "../../repositories/diario_obra_repository";

// DeleteDiarioObraImagensUseCase

export class DeleteDiarioObraImagensUseCase implements IDeleteDiarioObraImagensUseCase {
  constructor(private readonly repository: IDiarioObraRepository) {}

  async deleteDiarioObraImagens(IdDiarioObras: number, IdDiarioObrasImagens: number): Promise<void> {
    await this.repository.deleteDiarioObraImagens(IdDiarioObras, IdDiarioObrasImagens);
  }
}
